import { AnyAction } from 'redux';

import { myFleetActions } from '../reducer/reducer';

export const resetSelectedMobileLocation = (): AnyAction => myFleetActions.setSelectedMobileLocation(null);
